module.exports = __webpack_public_path__ + "static/media/T10.PNG.680f804d.png";